import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f8c0d6ca")

_pushScopeId("data-v-f8c0d6ca")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Note spesa")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "nuova_spesa" }
const _hoisted_5 = {
  key: 0,
  class: "no_spese_container"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "no_spese" }, "Nessuna nota spesa inserita", -1)
const _hoisted_7 = {
  key: 1,
  class: "container_spese"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "section_title" }, "Le tue spese", -1)
const _hoisted_9 = { class: "spesa_info" }
const _hoisted_10 = { class: "first_row" }
const _hoisted_11 = { class: "importo" }
const _hoisted_12 = { class: "data" }
const _hoisted_13 = { class: "descrizione" }
const _hoisted_14 = {
  key: 0,
  class: "allegati"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "block_title" }, "Allegati", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadNotaSpese()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", {
                    class: "spesa_button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.openModal && $setup.openModal(...args)))
                  }, "Nuova spesa")
                ]),
                (!$setup.note_spese.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _hoisted_6
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_7, [
                      _hoisted_8,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.note_spese, (nota) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "spesa",
                          key: nota.nota_spese_id,
                          onClick: ($event: any) => ($setup.openDetailModal(nota))
                        }, [
                          _createVNode("div", _hoisted_9, [
                            _createVNode("div", _hoisted_10, [
                              _createVNode("div", _hoisted_11, "€ " + _toDisplayString(nota.nota_spese_importo), 1),
                              _createVNode("div", {
                                class: ["badge", $setup.setStatusColor(nota.nota_spese_stato)]
                              }, _toDisplayString(nota.nota_spese_stato_value), 3)
                            ]),
                            _createVNode("div", _hoisted_12, _toDisplayString($setup.dateFormat(nota.nota_spese_data)), 1),
                            _createVNode("div", _hoisted_13, _toDisplayString($setup.setShortDescription(nota.nota_spese_descrizione)), 1),
                            (nota.nota_spese_foto_ricevuta)
                              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                                  _hoisted_15,
                                  _hoisted_16,
                                  _createVNode(_component_ion_thumbnail, { class: "img_thumbnail" }, {
                                    default: _withId(() => [
                                      _createVNode("img", {
                                        src: $setup.setImageUrl(nota.nota_spese_foto_ricevuta)
                                      }, null, 8, ["src"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, ["onClick"]))
                      }), 128))
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})